import type { ReactNode } from 'react';
import { tv } from 'tailwind-variants';

const badge = tv({
  base: 'inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-medium',
  variants: {
    tone: {
      neutral: 'bg-sunken text-fg-muted',
      accent: 'bg-accent-soft text-accent-fg',
      warning: 'bg-warning-soft text-warning-fg',
    },
  },
});

export interface BadgeProps {
  tone?: 'neutral' | 'accent' | 'warning';
  children: ReactNode;
}

/** A short status or role label. Always text, never color alone. */
export function Badge({ tone = 'neutral', children }: BadgeProps) {
  return <span className={badge({ tone })}>{children}</span>;
}
